<!--  -->
<template>
  <div class="channel-nav">
    <div
      :class="['channel-nav-item', activeValue == item.value ? 'active-channel-nav-item' : '']"
      v-for="item in list"
      :key="item.value"
      @click="handleSelect(item.value)"
    >
      <p>{{ item.label }}</p>
      <p>{{ item.labelEn }}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: [],
    },
    activeValue: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    handleSelect(val) {
      this.$emit("update:activeValue", val);
      this.$emit("on-success", val);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.channel-nav {
  display: flex;
  align-items: flex-start;
  .channel-nav-item {
    margin-right: 110px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(51, 51, 51, 0.4);
    text-align: center;
    cursor: pointer;
    flex-shrink: 0;
    -webkit-flex-shrink: 0;
  }
  .active-channel-nav-item {
    color: #333333;
    position: relative;
    height: 40px;
    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 2px;
      background: #2b2b2b;
    }
  }
}
</style>
